import { useDispatch, useSelector } from "react-redux";
import { Banner } from "app/modules/shared/banner/Banner";
import { selectSessionExpired, setShowSessionExpired } from "./SessionExpiredSlice";

export const SessionExpiredBanner: React.FC = () => {
  const sessionExpired = useSelector(selectSessionExpired);
  const dispatch = useDispatch();

  if (!sessionExpired) return <div></div>;

  return (
    <Banner
      data-test-id="session-expired-banner__dismiss-button"
      title="Session Expired"
      iconClassName="fa-warning"
      textDark
      className="px-5 mb-4 mt-4"
      onDismiss={() => dispatch(setShowSessionExpired(false))}
    >
      Your session has expired. You will need to log in again.
    </Banner>
  );
};
